// @vendors
const get = require('lodash/object/get');

// @constants
const actionTypes = require('constants/actionTypes');
const { BROKER_ORDER_CANCEL, BROKER_ORDER_CONDITIONED_CANCEL } = require('constants/operationTypes');
const { API_ENTERPRISE_NUMBER, API_CENTER } = require('constants/index');

// @utilities
const apiURLBuilder = require('core/apiURLBuilder');
const { formatText } = require('core/i18n').i18n;
const { APIPost } = require('utilities/APIRequestHelper');

// @actions
const signaturePatternActions = require('actions/signaturePattern');
const { getContractActivities, getActivityDetails } = require('actions/brokerContractActivities');
const notification = require('actions/notifications');
const errorActions = require('actions/brokerError');

// @constants
const { BROKER_ORDERS_AND_MOVEMENTS_SALE_OPERATION_CONDITIONAL, BROKER_ORDERS_AND_MOVEMENTS_BUY_OPERATION_CONDITIONAL } = require('constants/index');

const showError = (error, dispatch, history) => {
    const errorKey = get(error, ['body', 'error'], '');
    dispatch(errorActions.show('brokerAPIErrors-' + errorKey, true, history));
};

const cancelOrderRequest = () => ({
    type: actionTypes.BROKER_ORDERS_AND_MOVEMENTS_CANCEL_REQUEST
});

const cancelOrderSuccess = data => ({
    type: actionTypes.BROKER_ORDERS_AND_MOVEMENTS_CANCEL_SUCCESS,
    payload: {
        data
    }
});

const cancelOrderFailure = error => ({
    type: actionTypes.BROKER_ORDERS_AND_MOVEMENTS_CANCEL_FAILURE,
    payload: {
        error
    }
});

const cancelOrderVerifyRequest = () => ({
    type: actionTypes.BROKER_ORDERS_AND_MOVEMENTS_CANCEL_VERIFY_REQUEST
});

const cancelOrderVerifySuccess = data => ({
    type: actionTypes.BROKER_ORDERS_AND_MOVEMENTS_CANCEL_VERIFY_SUCCESS,
    payload: {
        data
    }
});

const cancelOrderVerifyFailure = error => ({
    type: actionTypes.BROKER_ORDERS_AND_MOVEMENTS_CANCEL_VERIFY_FAILURE,
    payload: {
        error
    }
});

const isConditionated = (type) => (
    type === BROKER_ORDERS_AND_MOVEMENTS_SALE_OPERATION_CONDITIONAL ||
    type === BROKER_ORDERS_AND_MOVEMENTS_BUY_OPERATION_CONDITIONAL
);

const cancelOrder = (immOrder, verificationResponse, entry, history) => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        let requestData, url;
        if (isConditionated(immOrder.get('type'))) {
            const { codigoSituacion, codigoSubscripcion, numeroOperacionBolsa } = verificationResponse;
            requestData = {
                query: {
                    codigoSituacion,
                    codigoSubscripcion,
                    contrato: {
                        numerodecontrato: immOrder.get('contractNumber'),
                        producto: immOrder.get('productNumber')
                    },
                    dataToken,
                    numeroOperacionBolsa
                }
            }
            url = apiURLBuilder.getURL('brokerConditionalOrderCancel');
        } else {
            const { codigoEmision, codigoValor, datosOperacion } = verificationResponse;
            requestData = {
                query: {
                    codigoEmision,
                    codigoValor,
                    dataToken,
                    datosOperacion,
                    entrada: entry
                }
            }
            url = apiURLBuilder.getURL('cancelOrder');
        }

        const findContract = () => {
            const brokerJointContracts = getState().brokerJointContracts.get('byId');

            return brokerJointContracts.find(immContract => {
                return (
                    immContract.get('walletNumber') === immOrder.get('contractNumber') &&
                    immContract.get('productNumber') === immOrder.get('productNumber')
                );
            });
        };

        dispatch(cancelOrderRequest());
        return APIPost(dispatch, url, requestData)
            .then(
                response => {
                    dispatch(cancelOrderSuccess(response));
                    const message = formatText('broker-ordersAndMovementsCancelValueOrderSuccess');
                    dispatch(notification.success({ message }, { voice: message }));
                    const immContract = findContract();
                    dispatch(getContractActivities(immContract, null, history));
                }
            )
            .catch(
                response => {
                    showError(response, dispatch, history);
                    dispatch(cancelOrderFailure(response.error.description));
                    const message = formatText('broker-ordersAndMovementsCancelValueOrderFailure');
                    dispatch(notification.error({ message }, { voice: message }));
                }
            )
    };
    const orderType = isConditionated(immOrder.get('type')) ? BROKER_ORDER_CONDITIONED_CANCEL : BROKER_ORDER_CANCEL;
    const operationParams = {
        chargeAccount: `${API_ENTERPRISE_NUMBER}${API_CENTER}${immOrder.get(
            'productNumber'
        )}${immOrder.get('contractNumber')}`
    };

    return dispatch(
        signaturePatternActions.processRequestConfiguration(orderType, operationParams)
    ).then(() => signaturePatternActions.validateAndExecute(dispatch, getState, callback));
};

const requestCancelAnOrder = (immOrder, history) => dispatch => {
    if (isConditionated(immOrder.get('type'))) {
        dispatch(getActivityDetails(immOrder))
            .then((response) => (dispatch(cancelOrder(immOrder, response.payload.data, null, history))))
            .catch(error => { throw error })
    } else {
        const entry = {
            contratoValores: {
                numerodecontrato: immOrder.get('contractNumber'),
                producto: immOrder.get('productNumber')
            },
            numeroOrden: immOrder.get('number'),
            tipoOrden: immOrder.get('type') && immOrder.get('type').charAt(0)
        };
        const requestData = {
            query: {
                entrada: entry
            }
        };

        dispatch(cancelOrderVerifyRequest());
        return APIPost(dispatch, apiURLBuilder.getURL('cancelOrderVerify'), requestData)
            .then(response => {
                dispatch(cancelOrderVerifySuccess(response));
                return dispatch(cancelOrder(immOrder, response, entry, history));
            })
            .catch(error => {
                showError(error, dispatch, history);
                dispatch(cancelOrderVerifyFailure(error));
            })
    }
}

const clearCancelAnOrderData = () => ({
    type: actionTypes.BROKER_ORDERS_AND_MOVEMENTS_CANCEL_CLEAR
});

module.exports = {
    requestCancelAnOrder,
    clearCancelAnOrderData
};
